import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';
import { ConfigureReminders, ConfigureRemindersParams } from './model';
import { ConfigureRemindersView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export function ConfigureRemindersRoute(
    model : (params : ConfigureRemindersParams) => ConfigureReminders,
    appWrapper : AppWrapper,
    request : Location
) : IRoute {
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <ConfigureRemindersView model={model(inboundParams(request))} />
            </AppWrapperView>
    };
}

function inboundParams(request : Location) : ConfigureRemindersParams {
    return {
        id: +(request.params['id'] || 0)
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/configurereminders/route.tsx